import { NUMBER_FILTER_OPERATION } from '../filter/operation.js';

export const DROPDOWN_NUMBER_OPTIONS = [
    [NUMBER_FILTER_OPERATION.equals.id, NUMBER_FILTER_OPERATION.doesNotEqual.id],
    [
        NUMBER_FILTER_OPERATION.greaterThan.id,
        NUMBER_FILTER_OPERATION.greaterThanOrEqual.id,
        NUMBER_FILTER_OPERATION.lessThan.id,
        NUMBER_FILTER_OPERATION.lessThanOrEqual.id,
        NUMBER_FILTER_OPERATION.between.id,
    ],
];
